import PropTypes from 'prop-types';

export const EmailPropType = PropTypes.shape({
  enabled: PropTypes.bool,
  destinations: PropTypes.arrayOf(PropTypes.string),
});

export const ChannelsPropType = PropTypes.shape({
  email: EmailPropType,
});

export const NotificationSettingsPropType = PropTypes.shape({
  channels: ChannelsPropType,
});
